import { fmtPrice } from "@/lib/totals";

const eur = (n) => fmtPrice(n);
const fmtDate = (iso, locale = "es-ES") => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d) ? iso.slice(0, 10) : d.toLocaleDateString(locale, { day: "2-digit", month: "2-digit", year: "numeric" });
};
const fmtDateTime = (iso, locale = "es-ES") => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d) ? iso : d.toLocaleString(locale, { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export { eur, fmtDate, fmtDateTime };
